self.addEventListener('message', (event) => {
  if (event.data && event.data === 'SKIP_WAITING') {
    self.skipWaiting();
  }
});
